import React, { useEffect, useState } from "react";
import { Modal, Row, Col, Skeleton, Dropdown, Menu, Input, Button } from "antd";
import "./Notifications.css";
import notification_icon from "../../assets/img/notification_icon.png";
import filterIcon from "../../assets/img/filtericon.svg";
import chat_icon from "../../assets/img/chat_icon.png";
import no_notificationIcon from "../../assets/img/No-Notification.png";
import no_chatIcon from "../../assets/img/chatIcon.png";
import NotificationItem from "./components/NotificationItem/NotificationItem";
import FilterConversations from "../../pages/Conversations/components/Filters/Filter";
import {
  SearchOutlined,
  CloseOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { fetchNotification, fetchInboxMessages , fetchHRMS, getConversationCountInit, markMessageAsRead } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loading/Loader";
import ConversationCard from "../../pages/Conversations/components/Messages/ConversationCard";
import history from "../../routes/history";
import InfiniteScroll from "react-infinite-scroll-component";
import { getCookie } from "../../shared/helpers";
import { useLocation } from "react-router-dom";
import { autoShowTooltip } from "aws-amplify";

export default function Notifications({ visible = () => {} , closeModal, isTabSwitch, setIsTabSwitch = () => {}, }) {
  const location = useLocation();
  const Icon = location?.state?.Icon;
  const dispatch = useDispatch();
  let userProfile = JSON.parse(localStorage.getItem("userProfile"));
  const finishProf = getCookie("finishProfile");
  const dummyRow = [1, 2, 3, 4];
  const [itemId, setItemId] = useState();
  const [conversationsRadioValue, setConversationsRadioValue] =
    useState("all_conversations");
  const [dropDownVisible, setDropDownVisible] = useState(false);
  const [bidStatusRadioValue, setBidStatusRadioValue] = useState("null");
  const [bidTypeRadioValue, setBidTypeRadioValue] = useState("all_bids");
  const [conversations, setConversations] = useState([]);
  const [hasMore, setHasMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const { pathname, search, state } = history.location;
  const isNotificationCheck = localStorage.getItem('isNotificationCheck');
  const [isNotification, setisNotification] = useState(isNotificationCheck === 'true' ? true : false);
  const mobileCheck = state?.fromMobileIsTabSwitch !== undefined ? state?.fromMobileIsTabSwitch : isNotification;

 
  const updatedState = {
    ...state,
    jobOrderId: "",
    jobType: "",
  };
  //REDUCERS***
  const inbox = useSelector((state) => state.messagesReducer.inbox);
  const counts = useSelector((state) => state.messagesReducer.counts);
  const conversationCounts = useSelector((state) => state.messagesReducer.conversationCount);
  const conversationCountsLoading = useSelector((state) => state.messagesReducer.conversationCountLoading);
  const inboxLoading = useSelector(
    (state) => state.messagesReducer.inboxLoading
  );
  const updateRequested = useSelector(
    (state) => state.fetchNotificationReducer.updateRequested
  );
  const notificationCont = useSelector(
    (state) => state.fetchNotificationReducer.notificationCount
  );
  const hasMorechats = useSelector(
    (state) => state.messagesReducer.hasMorechats
  );
  const page = useSelector((state) => state.messagesReducer.page);
  const [Count, setCount] = useState(counts?.data?.totalConversations);
  const [bidType,setBidType] = useState(null);
  const [bidStatusType,setBidStatusType] = useState(null);
  const [hrm_id,set_hrm_id] = useState(null);

  useEffect(()=>{
    dispatch(getConversationCountInit({
      bidType:bidType=='all_bids' ? null : bidType,
      bidStatus:bidStatusType,
      HRMid:hrm_id,
    }))
  },[bidType,bidStatusType,hrm_id])

  useEffect(() => {
    dispatch(fetchHRMS(userProfile));
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }
    useEffect(() => {
      dispatch(markMessageAsRead(itemId))
  }, [itemId])

  useEffect(() => {
    if (inbox?.data?.data?.body?.conversations) {
      setConversations(inbox?.data?.data?.body?.conversations);
    }
  }, [inbox]);

  useEffect(() => {
    if (updateRequested === true) {
      setTimeout(() => {
        dispatch(
          fetchNotification({
            currentPage: 1,
            pageSize: notification?.length,
            fetchMore: true,
            getAll: true,
          })
        );
      }, 2000);
    }
  }, [updateRequested]);
  const applyFilter = () => {
    if (bidTypeRadioValue == "placed_bids") {
      setCount(counts?.data?.allCount?.PlacedBids);
    } else if (bidTypeRadioValue == "received_bids") {
      setCount(counts?.data?.allCount?.ReceivedBids);
    } else if (bidTypeRadioValue == "all_bids") {
      setCount(counts?.data?.totalConversations);
    }
    if (hrmId && hrmId != userProfile.AccountId) {
      // dispatch(fetchMessagesCounts({ bidTypeRadioValue, hrmId }))
      dispatch(
        fetchInboxMessages(
          // bidTypeRadioValue,
          conversationsRadioValue,
          bidTypeRadioValue,
          bidStatusRadioValue,
          null,
          null,
          hrmId,
          true
        )
      );
      setTimeout(() => {
        dispatch(
          fetchInboxMessages(
            conversationsRadioValue,
            bidTypeRadioValue,
            bidStatusRadioValue,
            2,
            5,
            hrmId
          )
        );
      }, 1000);
    } else {
      // dispatch(fetchMessagesCounts(bidTypeRadioValue));
      dispatch(
        fetchInboxMessages(
          // bidTypeRadioValue,
          conversationsRadioValue,
          bidTypeRadioValue,
          bidStatusRadioValue,
          null,
          null,
          null,
          true
        )
      );
      setTimeout(() => {
        dispatch(
          fetchInboxMessages(
            conversationsRadioValue,
            bidTypeRadioValue,
            bidStatusRadioValue,
            2,
            5
          )
        );
      }, 1000);

      history?.replace({ pathname, search, state: updatedState });
    }


    setBidType(bidTypeRadioValue);
    setBidStatusType(bidStatusRadioValue);
    set_hrm_id(hrmId);

    // dispatch(
    //   getCandidateCount({
    //     bid_type_name: bidTypeName,
    //   })
    // );
    setshowHistory(false);
    // setLoadChat(true);

    setDropDownVisible(false);
    setshowHistory(false);
    // bidTypeRadioValue,
  };
  // const searchConversations = (text) => {
  // const filteredData = inbox?.data?.data?.body?.conversations?.filter(item => item.name.includes(searchString));
  // }

  const searchConversations = (e) => {
    let message_title;
    let message_name;
    let searchedConversations = inbox?.data?.data?.body?.conversations.filter(
      (item, index) => {
        message_name = item?.SenderUserName;
        if (item?.SourceTypeId == 1) {
          //SourceTypeName == "SkillListing"
          // skill listing based search
          message_title = item?.skillListing?.Title.toLowerCase();
        } else {
          message_title = item?.JobTitle?.toLowerCase();
        }
        if (
          message_title?.toLowerCase().includes(e.toLowerCase()) ||
          message_name?.toLowerCase().includes(e.toLowerCase())
        ) {
          return item;
        }
      }
    );

    if (e === "") {
      setConversations(inbox?.data?.data?.body?.conversations);
    } else {
      setConversations(searchedConversations);
    }
  };

  const clearFilter = () => {
    setBidStatusRadioValue(() => "null");
    setConversationsRadioValue(() => "all_conversations");
    setBidTypeRadioValue("all_bids");
    
    setBidType(null);
    setBidStatusType(null);
    set_hrm_id(null);

    dispatch(
      fetchInboxMessages(
        "null",
        "all_conversations",
        "null",
        1,
        null,
        null,
        true
      )
    );
    setTimeout(() => {
      dispatch(fetchInboxMessages("null", "all_conversations", "null", 2, 5));
    }, 1000);
    setDropDownVisible(false);
  };
  const [allNotification, setAllNotification] = useState([]);

  const [createdTime, setCreatedTime] = useState();
  const [showHistory, setshowHistory] = useState(false);
  const [inputWidth, setInputWidth] = useState(false);

  const [Recipient, setRecipient] = useState();
  const [title, setTitle] = useState();

  const [hrmId, sethrmId] = useState(null);
  const [infiniteLoading, setInfiniteLoading] = useState(false);

  const notification = useSelector(
    (state) => state.fetchNotificationReducer.notification
  );
  // const messageNotification = useSelector(
  //   (state) => state.messagesReducer.notification
  // );

  const loading = useSelector(
    (state) => state.fetchNotificationReducer.loading
  );
  useEffect(() => {
    if (Icon === "bell") {
      setisNotification(true)
    } else if (Icon === "message") {
      setisNotification(false) 
    }
  }, [Icon])

  useEffect(() => {
    if (location?.state?.openConversation == true) {
      dispatch(
        fetchInboxMessages(
          location?.state?.conversationStatus,
          conversationsRadioValue,
          bidStatusRadioValue,
          null,
          null,
          null,
          true,
          location?.state?.jobType,
          location?.state?.jobOrderId
        )
      );
      setTimeout(() => {
        dispatch(
          fetchInboxMessages(
            location?.state?.conversationStatus,
            conversationsRadioValue,
            bidStatusRadioValue,
            2,
            5,
            null,
            false,
            location?.state?.jobType,
            location?.state?.jobOrderId
          )
        );
      }, 1000);
    }
  }, []);

  useEffect(() => {
    setisNotification(
      window.innerWidth > 768 ? isTabSwitch : mobileCheck
      );
    }, [
      window.innerWidth > 768 ? isTabSwitch : mobileCheck,
      window.innerWidth > 768 && isNotification
    ]); 

  const goto = () => {
    if(history.location.pathname.includes("conversations")){
      history.replace("/conversations");
    }else{
    history.push("/conversations");

    }
    closeModal(false);
    visible(false);
  };
  useEffect(() => {
    setCount(counts?.data?.totalConversations);
  }, [counts]);
  const Filters = (
    <Menu className="chat-filter-menu">
      <FilterConversations
            conversationsRadioValue={conversationsRadioValue}
            setConversationsRadioValue={setConversationsRadioValue}
            bidTypeRadioValue={bidTypeRadioValue}
            setBidTypeRadioValue={setBidTypeRadioValue}
            bidStatusRadioValue={bidStatusRadioValue}
            setBidStatusRadioValue={setBidStatusRadioValue}
             hrmId={hrmId}
            sethrmId={sethrmId}
            counts={counts}
            IsHrm={userProfile}
      />
      <div className="statusDropDownBtnss">
        <Button className="clearBtnStatus" onClick={clearFilter}>
          Clear all
        </Button>

        <Button className="applyBtnStatus" onClick={applyFilter}>
          Apply
        </Button>
      </div>
    </Menu>
  );
  useEffect(() => {
    if (notification.length == 10) {
      setHasMore(true);
    }
  }, [notification]);

  const fetchMoreData = (value) => {
    setInfiniteLoading(true);
    dispatch(
      fetchNotification({
        currentPage: currentPage + 1,
        pageSize: pageSize,
        fetchMore: true,
      })
    );
    if (notificationCont == notification.length) {
      setHasMore(false);
    } else {
      setHasMore(true);
      setCurrentPage(currentPage + 1);
    }
  };

  const fetchMoreMsgs = (value) => {
    if (hasMorechats) {
      dispatch(
        fetchInboxMessages(
          conversationsRadioValue,
          bidTypeRadioValue,
          bidStatusRadioValue,
          page,
          5,
          hrmId,
          false,
          null,
          null,
          true
        )
      );
    }
  };


  return (
    <div className="notification">

      <Row
        className="notificationHeader"
      >
        <Row
          className="notificationCont"
          onClick={() => {
            setisNotification(true)
            localStorage.setItem('isNotificationCheck', true);
            window.innerWidth > 768 && setIsTabSwitch(true);
          }}
          
        >
          <div className="img_cont">
            <img
              className={!isNotification ? "blackIcon" : ""}
              src={notification_icon}
              alt="icon"
            />
          </div>
          <div className={`titleText ${isNotification ? "titleActive" : ""}`}>
            Notifications
          </div>
          <div className={`titleText ${isNotification ? "titleActive" : ""}`}>
            ({notificationCont})
          </div>
        </Row>
        <Row
          className="messagesCont"
          onClick={() => {
            if (!isNotification) {
              // history.push("/conversations");
              if(history.location.pathname.includes("conversations")){
                history.replace({
                  pathname: "/conversations",
                  state: {
                    fromNotification: true,
                  },
                });
              }
              else{
                history.push({
                  pathname: "/conversations",
                  state: {
                    fromNotification: true,
                  },
                });
              }

              visible(false);
            } else {
              dispatch(
                fetchInboxMessages(
                  "all_bids",
                  "all_conversations",
                  "null",
                  2,
                  5,
                  null,
                  false
                )
              );
            }
            setisNotification(false);
            localStorage.setItem('isNotificationCheck', false);
            window.innerWidth > 768 && setIsTabSwitch(false);
          }}
        >
          <div className="img_cont">
            <img
              className={!isNotification ? "greenIcon" : ""}
              src={chat_icon}
              alt="icon"
            />
          </div>
          <div className={`titleText ${!isNotification ? "titleActive" : ""}`}>
            Inbox
          </div>
          <div className={`titleText ${!isNotification ? "titleActive" : ""}`}>
            {conversationCountsLoading? <LoadingOutlined/>:`(${conversationCounts})`}
          </div>

        </Row>
      </Row>
      {/* } */}


      {/* case where Notifications Tab is set */}
      {isNotification ? (
        !infiniteLoading && loading ? (
          <div className="cardsContainer">
            <Loader />
          </div>
        ) : notification.length === 0 ? (
          <div className="notification-items-container">
            <Row className="no_msgsCont">
              <div className="imageContainer-notifications">
                <img width={135} src={no_chatIcon} alt="no notification icon" />
                <div style={{margin: '2.5% 0% 0% 2%'}} >No Notifications</div>
              </div>
            </Row>
          </div>
        ) : (
          <InfiniteScroll
            dataLength={notification?.length}
            next={fetchMoreData}
            hasMore={hasMore}
            height={(windowDimensions.width < 768) ? "100vh" : "65.5vh"}
            loader={hasMore ? <LoadingOutlined /> : null}
            className="notifications-scroller"
          >
            <Row className="notificationListCont notificationListCont-Mobile">
              {notification?.notification
                ? notification?.notification?.map((item, index) => {
                  // if (item?.conversationId) {
                  return (
                    <Col span={24} key={index}>
                      <NotificationItem
                        
                        item={item}
                        key={index}
                        index={index}
                        message={item?.Message}
                        type={item?.NotificationTypeName}
                        created={item?.Created}
                        img={item?.senderprofile[0]?.Profiles?.PictureUrl}
                        interviewer={item.senderprofile[0]?.UserName}
                        startTime={
                          item?.interviews &&
                          item?.interviews?.length &&
                          item?.interviews[0]?.Created
                        }
                        scheduleTimings={
                          item?.interviews &&
                          item?.interviews?.length &&
                          item?.interviews[0]?.Interviews_ScheduledTimings[0]
                            ?.StartTime
                        }
                        visible={visible}
                      />
                    </Col>
                  );
                  // }
                })
                : notification?.map((item, index) => {
                  return (
                    <Col span={24} key={index}>
                      <NotificationItem
                        item={item}
                        key={index}
                        index={index}
                        message={item?.Message}
                        type={item?.NotificationTypeName}
                        created={item?.Created}
                        img={item?.senderprofile[0]?.Profiles?.PictureUrl}
                        interviewer={item.senderprofile[0]?.UserName}
                        startTime={
                          item?.interviews &&
                          item?.interviews?.length &&
                          item?.interviews[0]?.Created
                        }
                        scheduleTimings={
                          item?.interviews &&
                          item?.interviews?.length &&
                          item?.interviews[0]?.Interviews_ScheduledTimings[0]
                            ?.StartTime
                        }
                        visible={visible}
                      />
                    </Col>
                  );
                })}
            </Row>
          </InfiniteScroll>
        )
      ) : (
        // case where Inbox Tab is set
        <Row className="notificationListCont">
          <Row className="InboxFiltersCont">
            {inputWidth ? null : (
              <div className="conversationTitleCont">
                <div className="titleConversation">All conversations</div>
                {/* <div className="titleCount">
                  ({inbox?.data?.data?.body?.conversations?.length}) 
                </div> */}
              </div>
            )}
            <Row
              style={{
                width: inputWidth ? "100%" : "50%",
                justifyContent: !inputWidth ? "flex-end" : "center",
              }}
            >
              {inputWidth ? null : ( 
                <Dropdown
                  autoFocus={true}
                  trigger="click"
                  overlay={Filters}
                  visible={dropDownVisible}
                  onOpenChange={() => setDropDownVisible(!dropDownVisible)}
                >
                  <div
                    className="conversationfilterCont"
                    onClick={() => setDropDownVisible(!dropDownVisible)}
                  >
                    <div className="conversation-header-filter-image">
                      <img src={filterIcon} alt="filterIcon" />
                    </div>
                    {conversationCounts>0&&
                      <div className="conversation-header-filter-count">
                      {bidStatusRadioValue  == "null"  && hrmId && hrmId != userProfile.AccountId? 3 : bidStatusRadioValue  == "null" ? 3 : 4}
                    </div>
                    }
                  </div>   
                </Dropdown>
              )}
              <div
                className="filterSearchConversationCont"
                onClick={() => {
                  if(inputWidth==false){
                    setInputWidth(!inputWidth)
                  }
                }}
                style={{
                  width: inputWidth ? "18rem" : "2.5rem",
                  paddingTop: inputWidth ? "15px" : "0px",
                  paddingBottom: inputWidth ? "15px" : "0px",
                  transition: inputWidth && "width 1s",
                }}
              >
                <Input
                  type={"input"}
                  className="conversation-header-inputt"
                  prefix={
                    <SearchOutlined
                      style={{ color: "#7e7e7e", fontSize: "16px" }}
                    />
                  }
                  placeholder="Find skill listing title or gig title"
                  onChange={(e) => searchConversations(e.target.value)}
                />
                {inputWidth && (
                  <div
                    className="cross-icon-divv"
                    onClick={() => setInputWidth(!inputWidth)}
                  >
                    <CloseOutlined style={{ color: "#c4c4c4" }} />
                  </div>
                )}
              </div>
            </Row>
          </Row>

          {/* Inbox data */}
          <div
            className="notification-cards-container"
            aria-details={
              inbox?.data?.data?.body?.conversations?.length > 0 && "extra-top"
            }
               style={{maxheight:(windowDimensions.width < 768)?"100vh":"65.5vh", minHeight:"min-content"}}
          >
              {inbox?.data?.data?.body?.conversations?.length > 0 ? (
                <InfiniteScroll
                  // dataLength={inbox?.data?.data?.body?.conversations?.length}
                  dataLength={conversations?.length}
                  next={fetchMoreMsgs}
                  hasMore={hasMorechats}
                  // scrollableTarget={"notification-cards-container"}
                  height={(windowDimensions.width < 768) ? "100vh" : "65.5vh"}
                className={"msgs-infinite-scroller"}
               
                  style={{ maxheight: (windowDimensions.width < 768) ? "100vh" : "70vh",
                    paddingTop: (windowDimensions.width < 768) ? "18px" : "0px"
                   }}

                loader={
                  hasMorechats &&
                    // inbox?.data?.data?.body?.conversations?.length >0 ? null 
                    conversations?.length > 0 ? null
                    : inboxLoading ? (
                      <>
                        {dummyRow.map((res, index) => {
                          return (
                            <div className="shimmer-container" key={index}>
                              {" "}
                              <Skeleton
                              key={index}
                                active
                                avatar
                                paragraph={{ rows: 2 }}
                              />{" "}
                            </div>
                          );
                        })}
                      </>
                    ) : (
                      <h4>No Conversations</h4>
                    )
                }
              >
                {/* {inbox?.data?.data?.body?.conversations?.map((item, index) => { */}
                <div style={{marginTop: windowDimensions.width < 768 ? "6rem" : null}}>                
                {conversations?.map((item, index) => {
                  if (windowDimensions.width > 768 && index > 8) {
                    return;
                  } else
                    return (
                      <Col
                      key={index}
                        span={24}
                        onClick={() => {
                          if (visible) visible(false);
                        }}
                      >
                        <ConversationCard
                          records={item}
                          SourceId={item?.BidId}
                          setshowHistory={setshowHistory}
                          setTitle={setTitle}
                          setCreatedTime={setCreatedTime}
                          setItemId={setItemId}
                          title={title}
                          SourceName={
                            item?.SourceTypeId === 1 //SourceTypeName === "SkillListing"
                              ? "Bid"
                              : "Proposal"
                          }
                          // setJobTitle={setJobTitle}
                          fromNotificationScreen={true}
                        />
                      </Col>
                    );
                })}
              </div>
              </InfiniteScroll>
            ) : (
              inboxLoading ? <Loader/> :
              (<div style={{marginLeft: windowDimensions.width > 768 ? "10.5rem" : "0"}}>
                <Row className="no_msgsCont">
                <div className="imageContainer">
                  <img
                    width={135}
                    src={no_chatIcon}
                    alt="no notification icon"
                  />
                  <div style={{marginTop: windowDimensions.width > 768 ? '8.5%' : '2.5' , marginLeft: windowDimensions.width > 768 ? '6%':'3%'}} >No Conversations</div>
                </div>
              </Row>
              </div>
              )
            )}
          </div>

            {(conversations?.length>0 && windowDimensions.width > 768)&&<div
              style={{
                marginBottom: "5px",
                paddingRight: "0.5rem",
                textAlign: 'end',
                display: "block",
                boxSizing: "border-box",
                width: "100%",
                color: "#4054b2",
                cursor: "pointer",
                borderTop: '1px solid #e4e4e4',
              }}
              onClick={goto}
            >
              View All
            </div>}
        </Row>
      )}
      { }
    </div>
  );
}
